import { useQuery } from 'react-query';
import { performanceService } from 'performance/services/performanceService';

export function usePerformanceQuery() {
  return useQuery(['performanceService_getPerformance'], () => performanceService.getPerformance(), {
    refetchInterval: 60000
  });
}
